module.exports = __webpack_public_path__ + "static/image/logo-family/logo_connect@2x.png?98f59e0a";